module.exports = __webpack_public_path__ + "static/media/casa nera.44747276.png";